module.exports = __webpack_public_path__ + "school/img/register.bf9b9889.jpg";